import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import { useEffect, useState } from "react";
import { api_url, AXIOS_HEADER } from "../../constants/data";
import axios from "axios";



const Monitoring = () => {
    const navigate = useNavigate(); // Initialize the navigate function
    const isAuthenticated = localStorage.getItem('auth_token')
    const userState = useSelector(state => state.auth);
    const[data, setData] = useState([])

    
    useEffect(() => {
        axios.post(`${api_url}/monitoring`, {}, AXIOS_HEADER).then(res => {
            setData(res.data)
        })
    }, [])

    return (
        <DashboardLayout>
            <div className="header_wrapper">
                <div className="header_icon">
                    <img src="/icons/flag.png" alt="" />
                </div>
                <div className="header_title">
                    <p>ეფექტურობის მონიტორინგი</p>
                </div>
            </div>

            <div className="task_list monitoring_list">
                <div className="task_list_header">
                    <div className="tr empty"></div>
                    <div className="tr department">
                        <p>შესრულებული</p>
                    </div>
                    <div className="tr anfang">
                        <p>შესრულებული დავალება</p>
                    </div>
                    <div className="tr department">
                        <p>შესასრულებელი იყო</p>
                    </div>
                    <div className="tr department">
                        <p>ყველა დავალება</p>
                    </div>
                    <div className="tr">
                        <p>%</p>
                    </div>

                    <div className="tr full">
                        <p>ბოლო შესვლა</p>
                    </div>
                </div>

                { data && data.map((item, index) => (
                    <div className="task_list_body">
                        <div className="tr empty">
                            <img src={item.image} alt="" style={{ width: '32px', borderRadius: '50%' }} />
                        </div>
                        <div className="tr department">
                            <p>{item.username}</p>
                        </div>
                        <div className="tr anfang">
                            <p>{item.finished}</p>
                        </div>
                        <div className="tr department">
                            <p>{item.shouldBeDone}</p>
                        </div>
                        <div className="tr department">
                            <p>{ item.total }</p>
                        </div>
                        <div className="tr">
                            <p>{ Math.round((item.finished / item.total) * 100)}%</p>
                        </div>
                        <div className="tr full">
                            <p>{ item.last_login }</p>
                        </div>
                    </div>
                )) }

            </div>

            <div className="task_pagination">
                <div className="tp_total">
                    <p>Total</p>
                    <div className="total_n">
                        <p>15</p>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    )
}
  
export default Monitoring